import CourseGradeExporter from './CourseGradeExporter';

export default CourseGradeExporter;
